import { render, staticRenderFns } from "./LpuItem.vue?vue&type=template&id=8ca2cca4"
import script from "./LpuItem.vue?vue&type=script&lang=js"
export * from "./LpuItem.vue?vue&type=script&lang=js"
import style0 from "./LpuItem.vue?vue&type=style&index=0&id=8ca2cca4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports